import React from 'react'
import { gameStatuses } from '../../pages/FingersBattlePage'
import './index.css'

export default function MainBoard({
  PlayerWin,
  PlayerOption,
  ComputerOption,
  gameStatus,
  handleRestartGame,
  scores = {
    user_score: 0,
    computer_score: 0
  }
}) {
  return (
    <>
      <div className="flex flex-row mt-2 justify-between h-80 relative gap-2">
        <div className="border-2 w-1/2 rounded text-center relative">
          computer:{ComputerOption} <br />
          user:{PlayerOption}
          {PlayerWin === "win" &&
            <div className="animation-displayer bg-blue-300 rounded">
              <p className="pulse text-white text-md">You Win</p>
            </div>
          }

        </div>
        <div className="border-2  w-1/2 text-center relative">
          computer:{ComputerOption} <br />
          user:{PlayerOption}
          {PlayerWin === "lose" &&
            <div className="animation-displayer bg-blue-300 rounded">
              <p className="pulse text-white text-md">Computer Won</p>
            </div>
          }
        </div>

        <div>
          {PlayerWin === "draw" &&
            <div className="draw-displayer bg-yellow-200 text-center rounded">
              <h1 className="pulse text-white">Draw</h1>
            </div>
          }
        </div>

        <div>
          {gameStatus === gameStatuses.ENDED &&
            <div className="draw-displayer bg-yellow-200 text-center rounded">
              {
                scores.user_score > scores.computer_score ?
                  <h3 className="pulse text-white">You Won</h3> :
                  scores.user_score === scores.computer_score ?
                    <h3 className="pulse text-white">Draw</h3>
                    : <h3 className="pulse text-white">You loose</h3>
              }
              <button className="bg-blue-400 text-white px-10 py-2 rounded" onClick={handleRestartGame}>Replay</button>
            </div>
          }
        </div>
      </div>
    </>
  )
}
